module.exports = __webpack_public_path__ + "img/business-photo.647519e3.jpg";